module.exports = __webpack_public_path__ + "images/emoji/notes.76fa020a37ed16cb0fa2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/notes.png
// module id = KOHF
// module chunks = 13